
import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PrimeNgArrayD4Component } from '../shared/prime-ng-array-d4/prime-ng-array-d4.component';
import { MaterialModule } from '../material-module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { GetJsonObjectService } from '../shared/services/get-json-object.service';
import { PutJsonObjectService } from '../shared/services/put-json-object.service';
import { first, Observable, tap } from 'rxjs';
import { columnDefinition, twoLinesDisplay } from '../shared/prime-ng-array-d4/prime-ng-array-d4.service';
import { environment } from '../../environments/environment';
import { deviceService } from '../shared/servicesHardware/deviceService';

@Component({
  standalone: true,
  selector: 'app-pa',
  imports: [CommonModule, MatProgressSpinnerModule, PrimeNgArrayD4Component, MaterialModule],
  templateUrl: './pa.html',
  styleUrl: './pa.scss'
})

export class PA {
  public columnsDefinition: columnDefinition[] = [];
  public orders: any[] = [];
  public loading: boolean = true;
  private readonly paApiBaseUrl = environment.paApiBaseUrl;
  private dowloadImgB64: string = "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwMDAwIj48cGF0aCBkPSJNNDgwLTMyMCAyODAtNTIwbDU2LTU4IDEwNCAxMDR2LTMyNmg4MHYzMjZsMTA0LTEwNCA1NiA1OC0yMDAgMjAwWk0yNDAtMTYwcS0zMyAwLTU2LjUtMjMuNVQxNjAtMjQwdi0xMjBoODB2MTIwaDQ4MHYtMTIwaDgwdjEyMHEwIDMzLTIzLjUgNTYuNVQ3MjAtMTYwSDI0MFoiLz48L3N2Zz4="
  private myCompanies: any[] = [];
  public canDownload: boolean = false;
  public canUpload: boolean = false;

  constructor(
    private getJsonObjectService: GetJsonObjectService,
    private putJsonService: PutJsonObjectService,
    private deviceService: deviceService,
    private httpClient: HttpClient
  ) {
    this.getMyCompanies().pipe(first()).subscribe(() => {
      this.getInvoicesPA();
    });
    this.columnsDefinition = [
      { displayName: "Numéro facture", name: "invoiceNumber", readOnly: true, ngStyle: { 'flex.px': '0 0 160' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Direction", name: "direction", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'enum', enum: [{ value: "incoming", displayValue: "Entrant" }, { value: "outgoing", displayValue: "Sortant" }], drop: null, localFilter: true },
      { displayName: "Montant total", name: "total_amount", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'currency', enum: null, drop: null, localFilter: true },
      { displayName: "Vendeur", name: "seller_name", readOnly: true, ngStyle: { 'flex.px': '0 0 200' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Mandat vendeur", name: "seller_siren", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Acheteur", name: "buyer_name", readOnly: true, ngStyle: { 'flex.px': '0 0 200' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Mandat Acheteur", name: "buyer_siren", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Date de réception", name: "receptionDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: true },
      { displayName: "download", name: "download", readOnly: true, ngStyle: { 'flex.px': '1 0 80', 'cursor': 'pointer' }, type: 'icon', enum: null, drop: null, localFilter: false },
    ];

    let me = localStorage.getItem("me");
    if (me) {
      let meObj = JSON.parse(me);
      console.log("meObj", meObj);
      if (meObj?.permissions?.length > 0) {
        meObj.permissions.forEach((permission: any) => {
          // Add your logic here  
          if (permission?.facturXUploadAccessLevel == 1) { //one acces in any company, then can upload
            this.canUpload = true;
          }
          if (permission?.facturXDownloadAccessLevel == 1) { //one acces in any company, then can download
            this.canDownload = true;
          }
        })
      }
    }
  }

  public rowAction(event: any) {
    console.log(event);
    if (event.actionName == 'download') {
      let order = this.orders.find(order => order.id === event.id);
      this.downloadPDF(order.download, order.invoiceNumber + ".pdf", order.companyIndex);
    }
  }

  private hasValidHeaderValue(value: any): boolean {
    return typeof value === 'string' && value.trim() !== '';
  }

  private downloadPDF(url: string, pdfName: string, companyIndex: number): void {
    const company = this.myCompanies[companyIndex];
    const paName = company?.companyFacturXPlatform;
    const subscriberId = company?.companyUniqueId;
    const paSubscriberId = company?.companyFacturXPlatformSubscriberId;
    const authorization = environment.PAAccess['Authorization'];

    if (!this.hasValidHeaderValue(paName)
      || !this.hasValidHeaderValue(subscriberId)
      || !this.hasValidHeaderValue(paSubscriberId)
      || !this.hasValidHeaderValue(authorization)) {
      console.warn('Download PA skipped because one header value is empty', {
        paName,
        subscriberId,
        paSubscriberId,
        hasAuthorization: this.hasValidHeaderValue(authorization),
      });
      return;
    }

    const headers = new HttpHeaders({
      'X-PA-Name': paName,
      'X-Subscriber-Id': subscriberId,
      'x-subscriber-pa-id': paSubscriberId,
      'Authorization': 'x-api-static-key ' + authorization,
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
      'Cache-Control': 'no-cache',
    });

    console.log("Downloading PDF from URL:", url);
    this.httpClient.get(url, { headers, responseType: 'blob' }).pipe(first()).subscribe(
      (blob: Blob) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = pdfName;
        downloadLink.click();
        window.URL.revokeObjectURL(downloadLink.href);
      },
      (error) => {
        console.error('Erreur lors du téléchargement du PDF', error);
      }
    );
  }

  public refresh() { this.loading = true; this.orders = []; this.getInvoicesPA(); }

  private getMyCompanies(): Observable<any[]> {
    return this.getJsonObjectService
      .getJson('support/companies/my')
      .pipe(
        first(),
        tap((companies: any[]) => {
          this.myCompanies = companies;
          console.log("My Companies:", this.myCompanies);
        })
      );
  }

  private getInvoicesPA() {
    if (this.myCompanies.length == 0) {
      this.loading = false;
      return;
    }

    for (let i = 0; i < this.myCompanies.length; i++) {
      const company = this.myCompanies[i];
      console.log("Company:", company);
      const paName = company?.companyFacturXPlatform;
      const subscriberId = company?.companyUniqueId;
      const paSubscriberId = company?.companyFacturXPlatformSubscriberId;
      const authorization = environment.PAAccess['Authorization'];

      if (this.hasValidHeaderValue(paName)
        && this.hasValidHeaderValue(subscriberId)
        && this.hasValidHeaderValue(paSubscriberId)
        && this.hasValidHeaderValue(authorization)) {
        const headers = new HttpHeaders({
          'X-PA-Name': paName,
          'X-Subscriber-Id': subscriberId,
          'x-subscriber-pa-id': paSubscriberId,
          'Authorization': 'x-api-static-key ' + authorization,
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
          'Cache-Control': 'no-cache',
        });
        console.log("Fetching invoices for company:", company.companyFacturXPlatform, "with headers:", headers);

        this.httpClient.get<any>(`${this.paApiBaseUrl}/invoices/latest`, { headers }).pipe(first()).subscribe(
          (response: any) => {
            this.initialData(response?.invoices || [], i);
          },
          (error) => {
            console.error('Erreur lors de la récupération des factures', error);
          }
        );
      } else {
        console.warn('Skipping PA invoices call because one header value is empty', {
          paName,
          subscriberId,
          paSubscriberId,
          hasAuthorization: this.hasValidHeaderValue(authorization),
        });
      }
    };
    this.loading = false;
  }

  private initialData(invoices: any[], companyIndex: number) {
    invoices.forEach((invoice: any) => {
      this.orders.push({
        id: invoice.invoice_number,
        invoiceNumber: invoice.invoice_number,
        download: `${this.paApiBaseUrl}/invoice/detail/${invoice.invoice_id}`,
        direction: invoice.direction,
        buyer_siren: invoice.buyer.peppol_id ? invoice.buyer.peppol_id.split(":")[1] : "",
        buyer_name: invoice.buyer.name,
        seller_siren: invoice.seller.peppol_id ? invoice.seller.peppol_id.split(":")[1] : "",
        seller_name: invoice.seller.name,
        total_amount: invoice.total_amount,
        receptionDate: new Date(invoice.created_at),
        subscriberName: "",
        companyIndex: companyIndex,
      });
    });
    this.loading = false;
  }
}
